import React, {Component} from 'react';
import {Label} from 'semantic-ui-react';
import connect from "react-redux/es/connect/connect";
import {selectProduct} from "../../actions/ProductSelectActions";
import {openModalProductStock} from "../../actions/ModalProductStockActions";

class ProductStock extends Component {
    handelClick = () => {
        this.props.selectProduct(this.props);
        this.props.openModalProductStock({id: this.props.id, name: this.props.name, is_open:true})
    };

    render() {
        return this.props.stock && this.props.product_type !== 'V' ? <Label as='a' color='orange' onClick={this.handelClick}>{`Inventario - ${this.props.count_stock} unidades`}</Label>:<Label>No Aplica</Label>;
    }
}

function mapDispatchToProps(dispatch){
    return {
        selectProduct(data) {
            dispatch(selectProduct(data));
        },
        openModalProductStock(data){
            dispatch(openModalProductStock(data))
        },
    }
}


export default connect(
    null,
    mapDispatchToProps
)(ProductStock)


// WEBPACK FOOTER //
// ./src/components/inventories/ProductStock.js